<template>
    <div class="logobar">
        <div class="container">
            <router-link :to="logoTo" class="logo">
                <template v-if="currentCategoryImage">
                    <img :src="currentCategoryImage" :alt="currentCategoryName" class="logo-category-img" />
                </template>
                <template v-else-if="shopLogo">
                    <img :src="shopLogo" :alt="appName" />
                </template>
                <template v-else>
                    <img src="/assets/img/header/header-bi.svg" :alt="appName" />
                    <img src="/assets/img/header/header-logo.svg" :alt="appName" />
                </template>
            </router-link>

            <!-- 모바일 우측 버튼 영역 -->
            <div class="mobile-actions d-flex d-md-none align-center">
                <router-link v-if="$route.name !== 'Login'" to="/cart" class="mobile-icon-btn" @click.native="closeMenu">
                    <i class="las la-shopping-cart"></i>
                    <span v-if="getCartCount > 0" class="mobile-cart-badge">{{ getCartCount }}</span>
                </router-link>
                <button class="hamburger-btn" @click="toggleActiveMenu" :class="{ open: isActiveMenu }">
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </div>
        </div>

        <!-- 모바일 풀스크린 메뉴 -->
        <div class="mobile-menu" v-show="isActiveMenu">
            <div class="menu-wrapper">
                <!-- 1단계 메뉴 -->
                <ul class="menu-list1">
                    <li
                        v-for="(item, i) in menuItems"
                        :key="i"
                        :class="{ active: currMenu === i }"
                        @click="currMenu = i"
                    >
                        {{ item.name }}
                    </li>
                </ul>
                <!-- 2단계 메뉴 -->
                <ul class="menu-list2" v-if="menuItems[currMenu] && menuItems[currMenu].children && menuItems[currMenu].children.length">
                    <li
                        v-for="(sub, j) in menuItems[currMenu].children"
                        :key="j"
                        :class="{
                            h: sub.badge === 'h',
                            n: sub.badge === 'n',
                            b: sub.badge === 'b',
                        }"
                    >
                        <router-link :to="sub.href || '/'" @click.native="closeMenu">
                            <i class="h-icon">H</i>
                            <i class="n-icon">N</i>
                            <i class="b-icon">B</i>
                            {{ sub.name }}
                        </router-link>
                    </li>
                </ul>
                <!-- 서브메뉴 없는 경우 바로 이동 링크 -->
                <ul class="menu-list2 no-sub" v-else-if="menuItems[currMenu] && menuItems[currMenu].href">
                    <li>
                        <router-link :to="menuItems[currMenu].href" @click.native="closeMenu">바로가기</router-link>
                    </li>
                </ul>
            </div>
            <!-- 모바일 메뉴 하단 계정 영역 -->
            <div class="mobile-menu-footer">
                <router-link v-if="!isAuthenticated" :to="shopSlugForLogin ? { name: 'Login', query: { shop_id: shopSlugForLogin } } : { name: 'Login', query: {} }" class="btn-login" @click.native="closeMenu">
                    <i class="las la-sign-in-alt"></i> 로그인
                </router-link>
                <template v-else>
                    <a v-if="isUseAfterLogin" :href="homeHref" class="btn-mypage" @click="closeMenu">
                        <i class="las la-home"></i> 홈
                    </a>
                    <router-link :to="{ name: 'DashBoard' }" class="btn-mypage" @click.native="closeMenu">
                        <i class="las la-user"></i> 마이페이지
                    </router-link>
                    <button class="btn-logout" @click="logout">
                        <i class="las la-sign-out-alt"></i> 로그아웃
                    </button>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    export default {
        name: 'LogoBarType6',
        props: {
            loading: { type: Boolean, required: true, default: true },
            data: {
                type: Object,
                default: {},
            },
        },
        data: () => ({
            openSearch: false,
            searchKeyword: '',
            isActiveMenu: false,
            currMenu: 0,
        }),
        computed: {
            ...mapGetters('app', ['appLogo', 'appName', 'banners', 'currentCategoryImage', 'currentCategoryName']),
            ...mapGetters('auth', ['isAuthenticated', 'currentUserShopSlug', 'isUseAfterLogin']),
            ...mapGetters('cart', ['getCartCount']),
            shopSlugForLogin() {
                if (this.$route.params.slug) return this.$route.params.slug;
                if (this.$route.query.shop_id) return this.$route.query.shop_id;
                const redirect = this.$route.query.redirect || '';
                return redirect.split('/').filter(Boolean)[0] || null;
            },
            logoTo() {
                const slug = this.currentUserShopSlug || this.$route.params.slug;
                return slug ? '/' + slug : { name: 'Home' };
            },
            shopLogo() {
                if (!this.data) return '';
                return this.data.shop_logo || this.data.home_shop_logo || '';
            },
            menuItems() {
                return (this.data && this.data.menu_items) || [];
            },
            homeHref() {
                return this.isUseAfterLogin ? '/after-login/' : '/mypage/dashboard';
            },
        },
        watch: {
            $route() {
                this.closeMenu();
            },
        },
        methods: {
            ...mapActions(['auth/logout']),
            ...mapActions('cart', ['resetCart']),
            ...mapActions('wishlist', ['resetWishlist']),
            async logout() {
                const shopSlug = this.currentUserShopSlug || window.shopSetting?.defaultShopSlug;
                try { await this.call_api('get', 'auth/logout'); } catch (_) {}
                this['auth/logout']();
                this.resetCart();
                this.resetWishlist();
                window.location.href = shopSlug ? `/${shopSlug}` : '/';
            },
            searchByEnter(e) {
                if (e.keyCode === 13) this.searchByKeyword();
            },
            searchByKeyword() {
                const keyword = this.$refs.searchInput ? this.$refs.searchInput.value : '';
            },
            toggleActiveMenu() {
                this.isActiveMenu = !this.isActiveMenu;
                if (this.isActiveMenu) {
                    document.body.style.overflow = 'hidden';
                } else {
                    document.body.style.overflow = '';
                }
            },
            closeMenu() {
                this.isActiveMenu = false;
                document.body.style.overflow = '';
            },
        },
    };
</script>
<style lang="scss" scoped>
    .logobar {
        height: 100%;
        position: relative;
        z-index: 1000;

        .container {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 100%;
            padding: 0;
            margin-top: 0 !important;

            @media (max-width: 959px) {
                padding: 0 16px;
            }

            .logo {
                display: flex;
                align-items: center;

                .logo-category-img {
                    height: 81px;
                    width: auto;
                    object-fit: contain;
                    padding-top:30px;
                    padding-left:20px;

                    @media (max-width: 959px) {
                        height: 36px;
                    }
                }

                img {
                    margin: 0;
                    padding: 0;
                    vertical-align: middle;
                    height: 51px;
                    width: auto;

                    @media (max-width: 959px) {
                        height: 36px;
                    }
                }
                img:has(+ img) {
                    height: 31px;
                    margin-right: 6px;

                    @media (max-width: 959px) {
                        height: 22px;
                        margin-right: 4px;
                    }
                }
                img + img {
                    height: 51px;

                    @media (max-width: 959px) {
                        height: 36px;
                    }
                }
            }
        }
    }

    /* ===== 모바일 우측 액션 버튼 ===== */
    .mobile-actions {
        gap: 8px;
    }

    .mobile-icon-btn {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        color: #000;

        i {
            font-size: 24px;
        }

        .mobile-cart-badge {
            position: absolute;
            top: 2px;
            right: 2px;
            min-width: 16px;
            height: 16px;
            padding: 0 4px;
            border-radius: 8px;
            background: #e62d04;
            color: #fff;
            font-size: 10px;
            line-height: 16px;
            text-align: center;
        }
    }

    /* ===== 햄버거 버튼 ===== */
    .hamburger-btn {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 5px;
        width: 36px;
        height: 36px;
        padding: 0;
        background: none;
        border: none;
        cursor: pointer;

        span {
            display: block;
            width: 22px;
            height: 2px;
            background: #000;
            transition: all 0.25s ease;
            transform-origin: center;
        }

        &.open {
            span:nth-child(1) {
                transform: translateY(7px) rotate(45deg);
            }
            span:nth-child(2) {
                opacity: 0;
                transform: scaleX(0);
            }
            span:nth-child(3) {
                transform: translateY(-7px) rotate(-45deg);
            }
        }
    }

    /* ===== 모바일 메뉴 오버레이 ===== */
    .mobile-menu {
        position: fixed;
        top: 75px;
        left: 0;
        right: 0;
        bottom: 0;
        background: #fff;
        border-top: 1px solid #e5e5e5;
        z-index: 999;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        ul {
            margin: 0;
            padding: 0;
            list-style: none;
        }

        .menu-wrapper {
            flex: 1;
            display: flex;
            align-items: stretch;
            overflow: hidden;

            .menu-list1 {
                width: 140px;
                flex-shrink: 0;
                overflow-y: auto;
                border-right: 1px solid #e5e5e5;

                li {
                    line-height: 46px;
                    font-size: 14px;
                    padding: 0 0 0 16px;
                    cursor: pointer;
                    border-bottom: 1px solid #f0f0f0;

                    &:hover,
                    &.active {
                        background: #f7f7f7;
                        font-weight: 500;
                    }
                }
            }

            .menu-list2 {
                flex: 1;
                background: #f7f7f7;
                padding: 10px 0;
                overflow-y: auto;

                &.no-sub {
                    padding: 16px;
                }

                li {
                    border-bottom: 1px solid #ebebeb;

                    &:last-of-type {
                        border-bottom: none;
                    }

                    a {
                        display: block;
                        padding: 12px 16px 12px 20px;
                        font-size: 14px;
                        line-height: 1.2;
                        color: #000;

                        &:hover {
                            font-weight: 500;
                        }
                    }

                    i {
                        display: none;
                        width: 14px;
                        height: 14px;
                        border-radius: 50%;
                        align-items: center;
                        justify-content: center;
                        vertical-align: middle;
                        color: #fff;
                        font-size: 8px;
                        font-style: normal;
                        position: relative;
                        top: -1px;
                        margin-right: 4px;

                        &.h-icon { background: #c20000; }
                        &.n-icon { background: #3e7af2; }
                        &.b-icon { background: #127017; }
                    }

                    &.h i.h-icon { display: inline-flex; }
                    &.n i.n-icon { display: inline-flex; }
                    &.b i.b-icon { display: inline-flex; }
                }
            }
        }

        .mobile-menu-footer {
            flex-shrink: 0;
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 16px;
            border-top: 1px solid #e5e5e5;
            background: #fff;

            a, button {
                display: flex;
                align-items: center;
                gap: 6px;
                padding: 8px 16px;
                font-size: 14px;
                color: #333;
                background: #f5f5f5;
                border: none;
                border-radius: 4px;
                cursor: pointer;
                text-decoration: none;

                i {
                    font-size: 18px;
                }
            }
        }
    }
</style>
